import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ModalContainerComponent } from './modal-container/modal-container.component';
import { ModalService } from './modal-service.service';

@NgModule({
  imports: [CommonModule],
  declarations: [ModalContainerComponent],
})
export class ModalServiceModule {
  static forRoot() {
    return {
      ngModule: ModalServiceModule,
      providers: [ModalService],
    };
  }
}
